import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-03, 16px);
  width: 100%;
  padding-right: var(--general-spacer-04, 24px);
`;

export const UrlList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-02, 8px);
  align-items: flex-start;
`;

export const ChipsWrapper = styled.div`
  margin-top: var(--general-spacer-02, 8px);
`;
